import Vue from 'vue'
import FeatherIcon from './components/global_UI/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
